// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- 3rd Party
import { User } from 'oidc-client';

// --- HS Code
import { SurveyBreakBaseService } from './survey-break-base.service';
import { SurveyResponseModel, SurveyStatuses } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class SurveyBreakMockService extends SurveyBreakBaseService {
  override loadContent(identity: User, surveyResponse: SurveyResponseModel): void {
    throw new Error('Method not implemented.');
  }
  override loadBySurveyStatus(surveyStatus: SurveyStatuses): void {
    throw new Error('Method not implemented.');
  }
  override loadBySurveyStatusAndGroupIndex(surveyResponse: SurveyResponseModel, groupIndex: number): void {
    throw new Error('Method not implemented.');
  }
}

